import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  GSFormContact,
  ContFirstFormContact,
  ContFormContact,
  ContAlertContact,
} from './FormContact.styles';
import {
  Alert,
  Collapse,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useWindowDimensions } from '../../utils';
import { useFormContact } from './useFormContact';
import DynamicForm from '../DynamicForm/index';
import { dataClient } from './validationSchema';

export const FormContact = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sizeInput, setSizeInput] = useState('small');
  const [reset, setReset] = useState(false);
  const [form, setForm] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    typeInstitution: '',
    interest: '',
    message: '',
    check_nocredit: false,
  });
  const [emailSend, setEmailSend] = useState(false);
  const {
    onSubmit,
    closeAlert,
    respSend,
  } = useFormContact();
  const { width } = useWindowDimensions();
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmitAccion = (values) => {
    if (!formSubmitted) {
      const payload = {
        ...values,
        subject: values.interest,
      };
      const sendValues = onSubmit(payload);
      if (sendValues === true) {
        setEmailSend(true);
        setFormSubmitted(true);
        setTimeout(() => {
          navigate('/gracias');
        }, 2000);
      }
    }
  };

  const resetForm = () => {
    setForm({
      name: '',
      company: '',
      email: '',
      phone: '',
      typeInstitution: '',
      interest: '',
      message: '',
      check_nocredit: false,
    });
    setReset(true);
  };

  useEffect(() => {
    setSizeInput(width > 1023 ? 'small' : 'small');
  }, [width]);

  useEffect(() => {
    if (emailSend === true) {
      resetForm();
    }
  }, [emailSend]);

  useEffect(() => {}, [reset]);

  return (
    <ContFirstFormContact id={'ContFirstFormContact'}>
      <GSFormContact />
      <ContAlertContact>
        <Collapse in={respSend.openAlert}>
          <Alert
            severity={respSend.status}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  closeAlert();
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 6 }}
          >
            <div dangerouslySetInnerHTML={{ __html: respSend.message }} />
          </Alert>
        </Collapse>
      </ContAlertContact>
      <ContFormContact id={'ContFormContact'}>
        {form && (
          <DynamicForm
            actions={[
              {
                color: 'primary',
                label: t('Enviar'),
                type: 'submit',
                typeButton: 'login',
                form: 'formContact',
                processing: formSubmitted,
                fn: () => {
                  handleSubmitAccion();
                },
              },
            ]}
            fields={[
              {
                label: t('Nombre completo'),
                name: 'name',
                placeholder: t('Ejemplo: Oswaldo Lopez'),
              },
              {
                label: t('Nombre de la empresa'),
                name: 'company',
                placeholder: t('Ejemplo: Dynamicore S.A. de C.V'),
              },
              {
                label: t('Email'),
                name: 'email',
                placeholder: t('Ejemplo: ejemplo@tucorreo.com'),
                type: 'email',
              },
              {
                label: t('Teléfono'),
                name: 'phone',
                type: 'phone_number',
                placeholder: '+52',
              },
              {
                label: t('¿Qué servicio necesitas para tu empresa?'),
                name: 'typeInstitution',
                type: 'select',
                settings: {
                  emptyElement: t('Selecciona un servicio'),
                  group: false,
                  options: [
                    {
                      id: 'SOFOM',
                      name: 'SOFOM',
                    },
                    {
                      id: 'SOFIPO',
                      name: 'SOFIPO',
                    },
                    {
                      id: 'SOFOL',
                      name: 'SOFOL',
                    },
                    {
                      id: 'IFPE',
                      name: 'IFPE',
                    },
                    {
                      id: 'otra',
                      name: t('Otra'),
                    },
                  ],
                },
              },
              {
                label: t('¿Qué servicio necesitas para tu empresa?'),
                name: 'interest',
                type: 'select',
                settings: {
                  emptyElement: t('Selecciona un servicio'),
                  group: false,
                  options: [
                    {
                      id: 'Quiero una demo',
                      name: t('Quiero una demo'),
                    },
                    {
                      id: 'Onboarding digital',
                      name: t('Onboarding digital'),
                    },
                    {
                      id: 'Candado para celulares',
                      name: t('Candado para celulares'),
                    },
                    {
                      id: 'Administración de Clientes/KYC',
                      name: t('Administración de Clientes/KYC'),
                    },
                    {
                      id: 'Configuración de productos',
                      name: t('Configuración de productos'),
                    },
                    {
                      id: 'PLD/Reportes regulatorios',
                      name: t('PLD/Reportes regulatorios'),
                    },
                    {
                      id: 'Notificaciones automatizadas',
                      name: t('Notificaciones automatizadas'),
                    },
                    {
                      id: t('Automatización de procesos'),
                      name: 'Automatización de procesos',
                    },
                    {
                      id: 'Otros',
                      name: t('Otros'),
                    },
                  ],
                },
              },
              {
                label: t('Ingresa tus comentarios'),
                name: 'message',
                type: 'textarea',
                placeholder: t('Ingresa texto...'),
              settings: {
                multiline: true,
                rows: 1,
                rowsMax: 1,
              },
            },
              {
                label: t('Entiendo que Dynamicore no ofrece ni otorga créditos de ningún tipo'),
                name: 'check_nocredit',
                size: 'medium',
                type: 'checkbox',
                settings: {
                  size: 'medium',
                },
                display: {
                  breakpoints: {
                    md: 12,
                  },
                },
              },
            ]}
            handleSubmitData={handleSubmitAccion}
            id="formContact"
            size={sizeInput}
            validationSchema={dataClient}
            initialValues={form}
          />
        )}
      </ContFormContact>
    </ContFirstFormContact>
  );
};
